import { useMutation } from '@src/query';


/**
 * Notification-center mutation hook (T10). Wraps the shared `useMutation` engine
 * with the injected-`queryClient` `mutateFn({ apiClient, queryClient })` contract
 * — the corelib query singleton is NOT imported here. Invalidation runs inside
 * `mutateFn`, the one place `queryClient` is injected; the caller threads the feed
 * `queryKey` it already holds from `useNotificationsQuery`, so the exact cache key
 * is preserved byte-for-byte against the original inline handler.
 *
 * Mirrors `query/settings/useNotificationMutations.js`: one
 * `query/<area>/use<Thing>Mutations.js` module re-exported through the
 * `@src/query` barrel.
 */

/**
 * Mark one or all notifications read. Variables: `{ payload, queryKey }`.
 * `payload` is either `{ ids: [...] }` (single row) or `{ all: true, seller }`
 * (mark-all-read), matching the original POST body. After the POST resolves the
 * feed query is invalidated so the unread badge + row dots refresh.
 */
function useNotificationMarkReadMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, payload, queryKey }) => apiClient
      .request({ url: '/notifications/mark-read/', method: 'POST', payload })
      .then((data) => queryClient.invalidateQueries({ queryKey }).then(() => data)),
    ...params,
  });
}


export { useNotificationMarkReadMutation };
